<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'webhooks', 'name': 'Webhooks'}]" />
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-button
        type="primary"
        shape="round"
        @click="showDrawer"
        style="margin-top:10px;margin-bottom:30px;"
      >Create new webhook</a-button>
    </a-skeleton>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list
        :dataSource="allWebhooks"
        itemLayout="horizontal"
        :pagination="pagination"
        :grid="{ size: 'middle'}"
      >
        <a-list-item slot="renderItem" slot-scope="webhook" :rowKey="webhook.id">
          <a
            @click="$router.push({ name: 'webhookEdit', params: { uuid: webhook.id }})"
            slot="actions"
            style="color: rgba(0, 0, 0, 0.45) !important;"
          >
            <a-icon type="form" style="padding:5px;"></a-icon>Edit
          </a>
          <a-list-item-meta
            class="clickable"
            @click="$router.push({ name: 'webhookEdit', params: { uuid: webhook.id } })"
            :description="'Receiving  URL: '+ webhook.url"
          >
            <a slot="title">
              Events subscribed to:
              <b>
                <a-tag color="pink">{{ webhook.event }}</a-tag>
              </b>
            </a>
            <a-avatar
              slot="avatar"
              shape="square"
              :size="48"
              icon="thunderbolt"
              style="background: #002e66;"
            />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
    <a-create-webhook v-if="!loading" />
  </div>
</template>

<script>
import ACreateWebhook from "@/components/Drawer/ACreateWebhook";

export default {
  data() {
    return {
      loading: true,
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 10
      }
    };
  },
  methods: {
    showDrawer() {
      this.$store.dispatch("ui/showDrawer", {
        drawer_name: "create_webhook"
      });
    },
    success() {
      this.$message.success("Secret copied.", 5);
    }
  },
  components: {
    ACreateWebhook
  },
  computed: {
    allWebhooks() {
      return this.$store.state.tenant.webhooks;
    }
  },

  beforeCreate: async function() {
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "webhooks"
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.webhook-id {
  display: inline-block;
  width: 150px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  background: white;
  padding: 5px;
  margin-left: 5px;
}

.ant-list-split .ant-list-item {
  border-bottom: 1px solid #e8e8e8 !important;
}

.ant-list-item-meta-avatar {
  padding-bottom: 5px;
}
.disabled {
  opacity: 0.7;
}
</style>
